export interface RegistrationCPGResponse {
  cta: string;
  description: string;
  disclaimer: string;
  filter: string;
  productTitle: string;
  promoCode: string;
  title: string;
  waterFilterUrl: string;
}
